import React, { useState, useEffect } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { useForm, UseFormReturn } from 'react-hook-form';
import './List.css';
import '../App.css';

import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from '../components/LoadingComponent';
import { LogField } from '../components/pictureLogPage/LogField';
import { SearchField } from '../components/pictureLogPage/SearchField';
import { useSnackbar } from 'notistack';

//api
import { getPictureLogs } from '../apicalls/cloud/pictureLog';
import {
  TFileLogSearchForm,
  TPictureLog
} from '../types/cloudStorage/CloudFileList';
import { TSelectItem } from '../types/common';

import { Snackbar } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { loginCheck } from '../utils/common';
import { createParams, getConstructionsSelectBoxData } from '../utils/common';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const PictureLogPage: React.FC = () => {
  const classes = useStyles();

  const history = useHistory();
  // 案件ID
  const constructId = 0;
  const constructIdDef = { value: 0, label: '--' };

  // 初期データ
  const defaultValues: TFileLogSearchForm = {
    construct_id: { value: 0, label: '--' },
    date_from: '',
    date_end: ''
  };

  // ログイン状態
  const [isLogin, setIsLogin] = useState<boolean>(false);
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState('');
  // エラーメッセージ表示フラグ
  const [open, setOpen] = useState(false);
  // ローディング表示フラグ
  const [loading, setLoading] = useState(false);

  // ログ一覧
  const [pictureLogs, setPictureLogs] = useState<TPictureLog[]>([]);

  // 案件セレクト用
  const [selectItem, setSelectItem] = useState<TSelectItem[]>([]);
  // 検索モード
  const [searchMode, setSearchMode] = useState<string>('');

  // hook-formの初期設定
  const methods: UseFormReturn<TFileLogSearchForm, any> = useForm({
    defaultValues
  });
  const {
    setValue,
    getValues,
    handleSubmit,
    reset,
    formState: { errors }
  } = methods;

  const { enqueueSnackbar } = useSnackbar();

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (constructId) {
      getPictureLogs();
    }

    // 工事セレクトボックスを取得
    getConstructionsSelectBoxData(setSelectItem, enqueueSnackbar, {
      value: 0,
      label: '--'
    });
  }, [constructId]);

  /**
   * 検索処理
   */
  const getPictureActionLogList = async (mode?: string) => {
    const formParams = {
      construct_id: getValues('construct_id')?.value,
      date_from: getValues('date_from'),
      date_end: getValues('date_end')
    };

    console.log('検索条件', formParams);

    if (!formParams.construct_id) {
      setPictureLogs([]);
      return;
    }

    const param: string = await createParams(formParams);

    await getPictureLogs(param).then(async data => {
      if (data === 'Not logged in!') {
        history.push('/');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setPictureLogs(data.data);
          }
        }
      }
    });
  };

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      {/* ヘッダー */}
      <AppBarComponent />
      {/* ローディング */}
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#FFFFFF',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          {/* ページタイトル */}
          <div style={{ backgroundColor: '#FFFFFF' }}>
            <div
              style={{
                fontWeight: 'bold',
                padding: 15,
                fontSize: 24
              }}
            >
              写真操作履歴
            </div>
          </div>

          {/* タブフィールド */}
          <div
            style={{
              backgroundColor: '#FFFFFF',
              padding: 20,
              display: 'flex'
            }}
          >
            <div
              className={classes.tab}
              onClick={() => history.push('/filelog')}
            >
              資料
            </div>
            <div className={classes.activeTab}>写真</div>
          </div>

          {/* 検索欄 */}
          <SearchField
            methods={methods}
            selectItem={selectItem}
            handleSubmit={handleSubmit}
            getValues={getValues}
            getPictureActionLogList={getPictureActionLogList}
            constructIdDef={constructIdDef}
            errors={errors}
            reset={reset}
          />
          {/* 操作履歴一覧 */}
          <LogField pictureLogs={pictureLogs} />
        </div>
      )}
      {/* フッター */}
      <FooterComponent />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    activeTab: {
      color: '#000000',
      fontSize: 14,
      border: '1px solid #cccccc',
      padding: 12,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      minWidth: 80
    },
    tab: {
      color: '#FFFFFF',
      fontSize: 14,
      border: '1px solid #cccccc',
      padding: 12,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#0099cc',
      minWidth: 80,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#52555f'
      }
    }
  })
);
